import { render, staticRenderFns } from "./Q&A.vue?vue&type=template&id=5abeca7d&"
import script from "./Q&A.vue?vue&type=script&lang=js&"
export * from "./Q&A.vue?vue&type=script&lang=js&"
import style0 from "./Q&A.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports